import "./droplist.scss";
import EventManager from "../eventManager.js";

export default class DropList extends EventManager {

    constructor ($target, options) {

        super();

        this.settings = $.extend({}, {
                $wrapper: null
            }, options);

        this.$target = $target;
        this.$target.attr('autocomplete', 'off');
        this.$target.blur(this.hide.bind(this));
        this.$target.keydown(this.keyboard.bind(this));

        this.create();

        this.lock = false;
    }

    create() {

        if (this.settings.$wrapper) {
            this.settings.$wrapper.addClass('droplist-wrapper');
        } else {
            this.$target
                .wrap('<div class="droplist-wrapper"/>');
        }

        this.$list = $('<ul/>').appendTo(
                this.$listContainer = $('<div/>', { class: 'droplist-container' })
                    .insertAfter(this.$target)
                    .hide()
            );

        this.$listContainer.mouseenter(event => this.lock = true);
        this.$listContainer.mouseleave(event => this.lock = false);

    }

    isVisible() {
        return this.$listContainer.is(":visible");
    }

    keyboard(event) {

        if (this.$listContainer.is(":visible")) {

            let $li = this.$list.find('li.hover').first();

            switch (event.which) {

                case 38: // up
                    if ($li !== null && !$li.is(':first-child')) {
                        $li.removeClass('hover');
                        $li.prev().addClass('hover');
                    }
                    event.stopPropagation();
                    break;

                case 40: // down
                    if ($li.length == 0 || !$li.is(':last-child')) {
                        if ($li.length > 0) {
                            $li.removeClass('hover');
                            if ($li.next().length) {
                                $li.next().addClass('hover');
                            }
                        } else {
                            this.$list.find('li:first-child').addClass('hover');
                        }
                    }
                    event.stopPropagation();
                    break;

                case 13:
                    if ($li.length > 0) {
                         this.onSelect($li);
                    }
                    break; // validate

            }
        }

    }

    show() {
        this.$listContainer.width(this.$target.outerWidth());
        this.$listContainer.slideDown();
    }

    hide() {
        if (!this.lock) {
            this.$list.find('li.hover').removeClass('hover');
            this.$listContainer.slideUp();
        }
    }

    populate(list) {

        let content = '';
        for (let value in list) {
            content += `<li data-value="${value}">${list[value]}</li>`;
        }

        this.$list.html(content);

        this.$list
            .find('> li')
            .click(event => this.onSelect($(event.delegateTarget)));

        this.show();

    }

    onSelect($choice) {

        this.lock = false;
        this.hide();

        super.on('select', $choice.attr('data-value'));

    }

}
